import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=cf0ec904&scoped=true&"
import script from "./Jitsi.vue?vue&type=script&lang=js&"
export * from "./Jitsi.vue?vue&type=script&lang=js&"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=cf0ec904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0ec904",
  null
  
)

export default component.exports